var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 13.1667V10.6667H5.5V7.33333H11.3333V4.83333L15.5 9L11.3333 13.1667ZM9.66667 0.666668C10.1087 0.666668 10.5326 0.842263 10.8452 1.15482C11.1577 1.46738 11.3333 1.89131 11.3333 2.33333V4H9.66667V2.33333H2.16667V15.6667H9.66667V14H11.3333V15.6667C11.3333 16.1087 11.1577 16.5326 10.8452 16.8452C10.5326 17.1577 10.1087 17.3333 9.66667 17.3333H2.16667C1.72464 17.3333 1.30072 17.1577 0.988155 16.8452C0.675595 16.5326 0.5 16.1087 0.5 15.6667V2.33333C0.5 1.89131 0.675595 1.46738 0.988155 1.15482C1.30072 0.842263 1.72464 0.666668 2.16667 0.666668H9.66667Z",
    fill: "#0D2548"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.713503dea8a172497360d0028c46ed4e.svg";
export { ForwardRef as ReactComponent };